export default __webpack_public_path__ + "static/media/chat_bubble.a5b58458.svg";